import React from 'react';

function BackTitle({ onClick, hoverText, title, subtitle }) {
    return (
        <div className="flex items-center p-2 pl-1">
            <button alt={hoverText} title={hoverText} onClick={onClick} className="px-3 py-2 text-gray-strongest bg-gray-weak hover:bg-gray-less rounded-full">
                <i className="fa-solid fa-arrow-left"></i>
            </button>

            {(title || subtitle) && (
                <div className="flex flex-col ml-3">
                    {title && (<h1 className="text-xl font-bold text-gray-strongest">{title}</h1>)}
                    {subtitle && (<span className="text-sm text-gray-mid">{subtitle}</span>)}
                </div>
            )}
        </div>
    );
}

export default BackTitle;
